import { createContext } from 'react';

const PreQualificationContext = createContext();

export default PreQualificationContext;
